import clipFlipLogo from '@/assets/logos/clipflip.svg'
import iqLogo from '@/assets/logos/IQ.svg'
import kovaLogo from '@/assets/logos/kova.svg'
import vitapicturaLogo from '@/assets/logos/vitapictura.svg'
import whaleLogo from '@/assets/logos/whale.svg'

/** Resolved URL for `<img src>` — Vite gives string URLs for imported SVGs. */
export const resolveCaseStudyClientLogo = (client: string): string | null => {
  const c = client.trim()
  if (/gosha\.ee/i.test(c)) {
    return '/favicon.svg'
  }
  if (/clip\s*flip|clipflip\.io/i.test(c)) {
    return clipFlipLogo
  }
  if (/kova\.ee|^kova$/i.test(c)) {
    return kovaLogo
  }
  if (/vitapictura/i.test(c)) {
    return vitapicturaLogo
  }
  if (/united\s+accountants|^united$/i.test(c)) {
    return '/clients/united-accountants-icon.avif'
  }
  if (/whale\.io/i.test(c)) {
    return whaleLogo
  }
  if (/iq/i.test(c)) {
    return iqLogo
  }
  return null
}
